import { DE$ } from '@infl-ts/util-datum';
import { defaultBaseUrl } from '@infl-ts/util-public-image-url';
import * as DE from '@nll/datum/lib/DatumEither';
import { pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import { createContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var defaultAppConfig = {
  modes: {
    activeLens: false,
    superAdmin: false
  },
  signupType: 'openSignup',
  programName: null,
  baseImageUrl: defaultBaseUrl
};
export var AppConfigContext = /*#__PURE__*/createContext(defaultAppConfig);
export var AppConfigProvider = function AppConfigProvider(_ref) {
  var options = _ref.options,
      children = _ref.children;
  return pipe(options, DE.map(O.map(function (appConfig) {
    var _appConfig$signupType, _appConfig$programNam, _appConfig$baseImageU;

    return {
      modes: {
        activeLens: appConfig.modes.includes('lens'),
        superAdmin: appConfig.modes.includes('superAdmin')
      },
      signupType: (_appConfig$signupType = appConfig === null || appConfig === void 0 ? void 0 : appConfig.signupType) !== null && _appConfig$signupType !== void 0 ? _appConfig$signupType : 'openSignup',
      programName: (_appConfig$programNam = appConfig === null || appConfig === void 0 ? void 0 : appConfig.programName) !== null && _appConfig$programNam !== void 0 ? _appConfig$programNam : null,
      baseImageUrl: (_appConfig$baseImageU = appConfig === null || appConfig === void 0 ? void 0 : appConfig.baseImageURL) !== null && _appConfig$baseImageU !== void 0 ? _appConfig$baseImageU : defaultBaseUrl
    };
  })), DE$.getSuccessOrElse(O.none), O.getOrElseW(function () {
    return defaultAppConfig;
  }), function (appConfig) {
    return /*#__PURE__*/_jsx(AppConfigContext.Provider, {
      value: appConfig,
      children: children
    });
  });
};